import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Typography, IconButton, Box, Button, TablePagination,
  TextField, Autocomplete
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import WasherDialog from './WasherDialog';
import FilterListAltIcon from '@mui/icons-material/FilterListAlt';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';

const LOCATION_OPTIONS = [
  "All",
  "Rachenahalli 1",
  "Rachenahalli 2",
  "Rachenahalli 3",
  "HegdeNagar 1",
  "HegdeNagar 2",
  "Bharatiya City 1",
  "Bharatiya City 2",
  "Bharatiya City 3",
  "Kannur 1",
  "Kannur 2",
  "Kannur 3",
  "WebCity 1",
  "WebCity 2",
  "Kothanur 1",
  "Kothanur 2",
  "Kothanur- Narayanpura 1",
  "Kothanur- Narayanpura 2",
  "Kothanur- Narayanpura 3",
  "Byrathi 1",
  "Hennur Main Road 1",
  "Hennur Cross 1",
  "Ashwath nagar 1"
];

const LAMP_TYPE_OPTIONS = [
  "Washer",
  "Car wash studio",
  "Tow buddy",
]

const Roles_options = [
  "Admin",
  "Manager",
  "Supervisor",
  "Agent",
  "Leader",
  "Washer"
]
const WasherList = () => {
  const [washers, setWashers] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editWasher, setEditWasher] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [locationFilter, setLocationFilter] = useState(null);

  useEffect(() => {
    fetchWashers();
    // eslint-disable-next-line
  }, [page, rowsPerPage, locationFilter]);

  const fetchWashers = () => {
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    let url = `${process.env.REACT_APP_SERVER_URI}/washers/list?page=${page + 1}&limit=${rowsPerPage}`;
    if (locationFilter) {
      url += `&location=${encodeURIComponent(locationFilter)}`;
    }
    fetch(url, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then(res => {
        console.log(res);
        return res.json()
      })
      .then(data => {
        console.log('Fetched washers:', data);
        if (!Array.isArray(data.data)) {
          console.error('Unexpected data format:', data);
          setWashers([]);
          setTotal(0);
          return;
        }
        setWashers(data.data);
        setTotal(data.total || data.data.length || 0);
      })
      .catch(err => {
        setWashers([]);
        setTotal(0);
        console.log(err)
        console.error('Error fetching washers:', err);
      });
  };

  const handleDialogOpen = () => {
    setEditWasher(null);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setEditWasher(null);
  };

  const handleWasherAdded = (washer) => {
    fetchWashers();
    setDialogOpen(false);
    setEditWasher(null);
  };

  const handleEditClick = (washer) => {
    setEditWasher(washer);
    setDialogOpen(true);
  };

  const handleDelete = (washerId) => {
    if (!window.confirm('Are you sure you want to delete this lamp?')) return;
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    console.log('Deleting washer with ID:', washerId);
    fetch(`${process.env.REACT_APP_SERVER_URI}/washers/delete/${washerId}`, {
      method: 'DELETE',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then(res => res.json())
      .then(() => {
        setWashers(washers => washers.filter(w => w.id !== washerId));
        setTotal(t => t - 1);
      })
      .catch(() => {
        alert('Failed to delete lamp.');
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  console.log('Rendering WasherList with washers:', washers);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, width: '1400', marginTop: '10rem' }}>
        <FilterListAltIcon sx={{ mr: 2 }} />
        {/* <Typography variant="h5" sx={{ flexGrow: 1 }}>Washer Management</Typography> */}
        <Grid container direction={"row" } spacing={2}>
        <Autocomplete
          options={LOCATION_OPTIONS}
          value={locationFilter}
          onChange={(event, value) => setLocationFilter(value)}
          sx={{ minWidth: 200, maxWidth: 250, mr: 2 }}
          renderInput={(params) => (
            <TextField {...params} label="Zone" margin="normal" />
          )}
        />
        <Autocomplete
          options={LAMP_TYPE_OPTIONS}
          value={locationFilter}
          // onChange={(event, value) => setLocationFilter(value)}
            sx={{ minWidth: 200, maxWidth: 250, mr: 2 }}
            renderInput={(params) => (
              <TextField {...params} label="Lamp category" margin="normal" />
            )}
            />
            <Autocomplete
            options={Roles_options}
            value={locationFilter}
            onChange={(event, value) => setLocationFilter(value)}
            sx={{ minWidth: 200, maxWidth: 250, mr: 2 }}
            renderInput={(params) => (
              <TextField {...params} label="Roles" margin="normal" />
            )}
            />
            <Autocomplete
            options={['part time', 'full time']}
            value={locationFilter}
            onChange={(event, value) => setLocationFilter(value)}
            sx={{ minWidth: 200, maxWidth: 250, mr: 2 }}
            renderInput={(params) => (
              <TextField {...params} label="Employement" margin="normal" />
            )}
            />
            <Autocomplete
            options={['on demand', 'subscription']}
            value={locationFilter}
            onChange={(event, value) => setLocationFilter(value)}
            sx={{ minWidth: 200, maxWidth: 250, mr: 2 }}
            renderInput={(params) => (
              <TextField {...params} label="Type" margin="normal" />
            )}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
            <Checkbox color="primary" />
            <Typography variant="body1" sx={{ ml: 1 }}>
              Leader
            </Typography>
            </Box>
            <br />
            </Grid>
            <Grid container>
            <Autocomplete
            options={['moveable', 'unmovable']}
            value={locationFilter}
            onChange={(event, value) => setLocationFilter(value)}
            sx={{ minWidth: 200, maxWidth: 250, mr: 2 }}
            renderInput={(params) => (
              <TextField {...params} label="Movable" margin="normal" />
            )}
            />
            {/* <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleDialogOpen}
            >
            Add LAMP
            </Button> */}
            {/* Search box for phone and name */}
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
            <TextField
              label="Search by Name"
              variant="outlined"
              size="small"
              sx={{ mr: 2 }}
              // Add value and onChange handlers as needed
            />
            <TextField
              label="Search by Phone"
              variant="outlined"
              size="small"
              sx={{ mr: 2 }}
              // Add value and onChange handlers as needed
            />
            </Box>
            </Grid>

      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', width: 1400, ml: 0, mr: 'auto' }}>
        <Box sx={{ flex: 1 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Lamp Name</TableCell>
                  <TableCell>Location</TableCell>
                  <TableCell>Availability Time</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {washers.map((washer) => (
                  <TableRow key={washer.id}>
                    <TableCell>{washer.name}</TableCell>
                    <TableCell>{washer.location}</TableCell>
                    <TableCell>
                      {Array.isArray(washer.lampAvailability) && washer.lampAvailability.length > 0
                        ? washer.lampAvailability.map((slot, idx) =>
                            slot.from && slot.to
                              ? `${slot.from} - ${slot.to}`
                              : null
                          ).filter(Boolean).join(', ')
                        : '-'}
                    </TableCell>
                    <TableCell>{washer.status}</TableCell>
                    <TableCell>
                      <IconButton color="primary" onClick={() => handleEditClick(washer)}>
                        <EditIcon />
                      </IconButton>
                      <Button
                        variant="outlined"
                        size="small"
                        color="error"
                        onClick={() => handleDelete(washer._id)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={total}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </TableContainer>
          <Box sx={{ display: 'flex', gap: 2, mt: 2, justifyContent: 'flex-end' }}>
            <Button variant="contained">All Lamp</Button>
            <Button variant="outlined">Filtered List</Button>
          </Box>
          <Box sx={{ display: 'flex', width: '100%', mt: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-start' }}>
              <Button variant="outlined">View Lamp Issues</Button>
              <Button variant="outlined">View Weekoff</Button>
            </Box>
            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Button variant="contained">View Order</Button>
            </Box>
          </Box>
        </Box>
        <Box sx={{ width: 220, minWidth: 180, display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-end', ml: 4 }}>
          <Button variant="contained" onClick={handleDialogOpen}>Add Lamp</Button>
          <Button variant="outlined">Assign Leader</Button>
          <Button variant="outlined">Add Leader</Button>
          <Button variant="outlined">Add Agent</Button>
          <Button variant="outlined">Add Zone</Button>
          <Button variant="outlined">Add Street</Button>
        </Box>
      </Box>
      <WasherDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onSave={handleWasherAdded}
        washer={editWasher}
      />
    </Box>
  );
};

export default WasherList;
